<template>
  <div id="foot">
    <div class="main-wrap">
      <img src="../../assets/img/footer-logo.png" style="width: 180px" alt="" />
      <div class="middle">
        <ul>
          <li @click="jumpPage(0)">About us</li>
          <!-- <li @click="jumpPage(1)">Media reports</li> -->
          <!-- <li @click="jumpPage()">Brance joining</li> -->
          <li @click="jumpPage(2)">Public welfare channel</li>
          <li @click="jumpPage(3)">Site help</li>
          <li @click="jumpPage(4)">Course procedures</li>
          <li @click="jumpPage(5)">User agreement</li>
          <li @click="jumpPage(6)">Privacy policy</li>
        </ul>
      </div>
      <div class="right-block">
        <div @click="openLink()">
          <span>Copyright@深圳青豆教育科技有限公司</span>
          <span style="margin-left:20px">粤ICP备15077651号</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less'
export default {
  methods: {
    openLink() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
    },
    jumpPage(type) {
      if (type == 0) {
        window.open(process.env.ABOUT_US_LINK)
      } else if (type == 1) {
        window.open(process.env.MEDIA_LINK)
      } else if (type == 2) {
        window.open(process.env.PUBLIC_LINK)
      } else if (type == 3) {
        window.open(process.env.SITE_HELP_LINK)
      } else if (type == 4) {
        window.open(process.env.PROCEDURES_LINK)
      } else if (type == 5) {
        window.open(process.env.AGREEMENT_LINK)
      } else if (type == 6) {
        window.open(process.env.PRIVACY_LINK)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/global-components/NavFoot/index.vue